if ( pplang == 'mx') {
    var locale = 'mx';
    var helpurl = 'https://ultrapassport.com/help';
    var _lwidth = '3em';

    // GLOBALS = '// GLOBALS',
    var _globalnotice = `El Registro Para ${regname} ya esta abierto! &nbsp;&nbsp;  <a href="${regurl}"><em>Registrate Aquí</em> <i class="fas fa-chevron-right"></i></a>`;
    var _globalnotice2 = `El Registro Para ${regname} ya esta abierto!`;
    var _globalnoticereg = 'Revisa tu correo electrónico! Te acabamos de mandar las instrucciones para la venta de mañana.';
    var _maintenance = 'Ultra Passport no está disponible actualmente, por favor, vuelva pronto.';
    var _guestnotice = 'Debe iniciar session para ver esta pagina.';

    // FORM LABELS = '// LABELS',
    var _fullname = 'Nombre Completo';
    var _firstname = 'Nombre';
    var _lastname = 'Apellidos';
    var _email = 'Correo Electrónico';
    var _emailaddy = 'Dirección de Correo Electrònico';
    var _confirmemailaddy = 'Confirm Email Address';
    var _birthday = 'Fecha de Nacimiento';
    var _location = 'Locacion';
    var _country = 'Pais';
    var _homeevent = 'Evento de Casa';
    var _gender = 'Género';
    var _password = 'Contraseña';
    var _male = 'Masculino';
    var _female = 'Femenino';
    var _pleaseselect = 'Selecciona';
    var _signuptitle = 'Registro Ultra Passport';
    var _enteryouremail = 'Escribe tu Correo Electrònico';
    var _backtologin = 'Atrás para iniciar sesión';
    var _requestnewpass = 'Solicita Contraseña Nueva';
    var _on = 'Prendido';
    var _off = 'Apagado';

    // TEXT LABELS = '// TEXT LABELS',
    var _enrollmentavailable = 'Registro disponible';
    var _logintext = 'Iniciar sesión ';
    var _password = 'Contraseña';
    var _welcome = 'Bienvenido';
    var _account = 'Cuenta';
    var _myaccount = 'Mi Cuenta';
    var _mypassport = 'Mi Pasaporte';
    var _events = 'Eventos';
    var _points = 'Puntos';
    var _updates = 'Actualizaciones';
    var _signout = 'Cerrar Session';
    var _signin = 'Iniciar Session';
    var _signedin = 'Session Iniciada';
    var _signuptext = 'Registrate';
    var _nextlevel = 'Siguiente Nivel';
    var _forgot = 'Se te olvido tu contraseña?';
    var _subscribed = 'Subscrito';
    var _helpcenter = 'Centro de Ayuda';
    var _error = 'Error';
    var _silver = 'Plata';
    var _gold = 'Oro';
    var _platinum = 'Platino';

    // VALIDATION MESSAGES = '// VALIDATION MESSAGES',
    var _gendertext = 'Tienes que escoger un genero.';
    var _accepttext = 'Tienes que aceptar los terminos.';

    // EMAIL VERIFICATIONS = '// EMAIL VERIFICATIONS',
    var _resendverify = 'Renviar Verificacion de Correo Electronico';
    var _revalidate = 'Revisa tu correo electronico para validar tu nueva direccion de correo electronico';
    var _sendingverification = 'Enviando correo electronico de verificacion';
    var _verifysent = 'Correo electronico de verificacion enviado';
    var _emailverifydashboard = 'Asegurate de verificar tu email para tener acceso a avances y regirto de tickets.';
    var _emailverifyupdates = 'Asegurate de verificar tu email para activar actualizaciones de email.';

    // EDIT PAGE = '// EDIT PAGE',
    var _editaccount = 'Editar Cuenta';
    var _nochanges = 'Cambios no detectados';
    var _accountupdated = 'Cuenta modificada';
    var _emailupdatedstarted = 'Nuevo email debe ser verificado, revisa tu email para confirmar.';
    var _emailupdatedverified = 'Tu nuevo correo ya esta verificado.';
    var _passwordresetsent = 'Email para resetear enviado.';

    // FOOTER SIGNUP = '// FOOTER SIGNUP',
    var _startinput = 'Ingresa tu email para comenzar';
    var _starttext = 'No tienes cuenta? Registrate para tener acceso a eventos, puntos y mas!';
    var _getstarted = 'Empieza';

    // SIGNUP PAGE = '// SIGNUP PAGE',
    var _createaccount = 'Crear mi Cuenta';
    var _almost = 'Ya mero terminamos';
    var _almost2 = 'Felicidades $user_firstname por crear tu Cuenta Ultra Passport!';
    var _almost3 = 'Para activar su cuenta, <strong><u>DEBE validar su dirección de correo electrónico </u> </strong> haciendo clic en el enlace de confirmación que acabamos de enviar a <strong>$user_email</strong>.';
    var _almost4 = 'Si no has recibido ningún correo electrónico <strong> <u> consulta tu carpeta de correo no deseado </u> </strong> y agrega <strong><u>info@ultrapassport.com</u></strong> <strong><u>a tu libreta de direcciones</u></strong>.';
    var _almost5 = 'Continuar';
    var _createdsuccess = 'Cuenta creada';
    var _createdinfo = 'Tu cuenta esta siendo creada';
    var _accountactivated = 'Tu cuenta ya esta activada';
    var _accountverified = 'Tu email ya fue verificado';
    var _passwordresetsuccess = 'Restablecimiento de Contraseña exitoso';
    // UPDATES = '// UPDATES',
    var _updatestext1 = 'Debe iniciar sesión para registrarse para recibir actualizaciones.';
    var _updatestextPending = 'Verifique su dirección de correo electrónico para recibir actualizaciones.';
    var _updatessubsrcibe = 'Se ha suscrito a recibir actualizaciones para:';
    var _updatesunsubsrcibe = 'Has cancelado la suscripción para recibir actualizaciones de:';

    // REGISTRATION = '// REGISTRATION',
    var _rbtnbuy = 'Compra tus boletos ahora';
    var _regbuy = 'Compra tus boletos';
    var _rbtnregister = 'Registrate por boletos';
    var _rbtnclosed = 'Cerrado';
    var _rbtnsoon = 'Proximamente';
    var _rbtnupdates = 'Obtener actualizaciones';
    var _verifyemailregister = 'Debe verificar su dirección de correo electrónico antes de registrarse.';
    var _regbtnhtml = 'Registrado';
    var _regerror = 'Error !';
    var _regerror2 = 'Vuelva a intentarlo';
    var _regprocessing = 'Su registro está en proceso …';
    var _registersuccess = 'Registro exitoso';
    var _regaccepted = 'Su <u class="regtype"></u> registro fue aceptado en';
    var _regaccepted2 = 'Las instrucciones de compra de boletos se envían a su correo electrónico 24-48 horas antes salir a la venta.';
    var _regdone1 = 'Código de registro';
    var _regdone2 = 'Registrado en';
    var _regdone3 = 'Reenviar instrucciones de compra';


    // REGISTRATION CONFIRM = '// REGISTRATION CONFIRM',
    var _regtext1 = 'Está su información actualizada?';
    var _regtext2 = 'Confirme su información de registro paraz';
    var _regguest1 = 'Debe iniciar sesión para registrarse para eventos.z';
    var _regpending1 = 'Ya casi estás ahí!';
    var _regpending2 = 'Verifique su <strong> dirección de correo electrónico </strong> para desbloquear el acceso al registro.';
    var _updateinfobtn = 'Actualizar mi informaciónz';
    var _confirmreg = 'Confirmar mi registro';
    var privacytext = 'Política de privacidad';
    var termsofuse = 'Términos de Uso';
    var privacylink = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${privacytext}</a>`;
    var termslink = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${termsofuse}</a>`;
    var _agreesignup = `Acepto la ${privacylink} y los ${termslink} de ${upptextlogo}.`;
    var _agreesignup2 = `Al inscribirse, acepta la ${privacylink} y los ${termslink} de ${upptextlogo}.`;
    var _agreeregister = `Al registrarse, usted acepta la ${privacylink} y los ${termslink} de ${upptextlogo}.`;


    // PASSPORT LABELS  = '// PASSPORT LABELS ',
    var _action = 'Acción';
    var _awarded = 'Premiado';
    var _award = 'Premio';
    var _action = 'Acción';
    var _pointsexpire = '* Los puntos caducan después de 25 meses calendario';
    var _qualifydisclaimer = '* Por favor, tenga en cuenta que un "Full Ultra Festival" excluye: Road To Ultra, Ultra Beach y Resistance-only Events.';
    var _benefit = 'Beneficio';
    var _sample = 'Puntos otorgados';
    var _active = 'Activo';
    var _deleted = 'Eliminado';
    var _btn_dashboard = 'Tablero';
    var _btn_benefits = 'Beneficios';
    var _btn_qualify = 'Califica';
    var _btn_points = 'Mis Puntos';
    var _howtoqualify = 'Como Calificar';


    // POINT LABELS = '// POINT LABELS',
    var _points_manual = 'Ajuste del Administrador de Pasaportes';
    var _points_verify = 'Correo electrónico de cuenta verificado';
    var _points_attend_festival = 'Asiste a un Full Ultra Festival';
    var _points_attend_festival = 'Asiste a un evento de Road to Ultra';
    var _points_away_bonus = 'Asiste a un evento en otro continente';
    var _points_home_bonus_1 = 'Asista a su evento en casa';
    var _points_home_bonus_2 = 'Asista a su evento en casa x 2';
    var _points_home_bonus_3 = 'Asista a su evento en casa x 3';
    var leveltext = _silver;
    var nextlevel = _gold;
    

    // Errors : '// Errors',
    var errors = {
        'reset' : 'Correo electrónico no válido o token expirado.',
        'create' : 'Error de creación. Inténtalo de nuevo.',
        'general' : '¡Vaya! Algo salió mal. Asegúrese de que las cookies están habilitadas.',
        'password' : 'La contraseña debe tener al menos 8 caracteres.',
        'duplicateemail' : 'Cuenta de correo electrónico ya esta en uso.',
        'matchemail' : 'Tu correo electrónico no coincide, por favor confirma y vuelve a ingresar tu correo electrónico.',
        'loginfail' : 'El nombre de usuario y la contraseña que ingresó no coinciden con nuestros registros. Por favor revise e inténtelo de nuevo',
        'token' : 'Token Invalido, intenta iniciar sesión y <b>reenviar tu correo electrónico de verificación</b>',
        'birthday' : "You must be 18 years of age or older to enroll in Ultra Passport.",
    };

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : 'Ajuste del Administrador de Pasaportes',
        unknown : 'Ajuste del Administrador de Pasaportes',
        verify : 'Correo electrónico de cuenta verificado',
        attend_festival : 'Asiste a un Full Ultra Festival',
        attend_rtu : 'Asiste a un evento de Road to Ultra',
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : 'Asiste a un evento en otro continente',
        home_bonus_1 : 'Asista a su evento en casa',
        home_bonus_2 : 'Asista a su evento en casa x 2',
        home_bonus_3 : 'Asista a su evento en casa x 3+',
        home_bonus_4 : 'Asiste a su evento en casa x 3+',
        home_bonus_5 : 'Asiste a su evento en casa x 3+',
        home_bonus_6 : 'Asista a su evento en casa x 3+',
        home_bonus_7 : 'Asista a su evento en casa x 3+',
        home_bonus_8 : 'Asiste a su evento en casa x 3+',
        home_bonus_9 : 'Asiste a su evento en casa x 3+',
    };
}
